var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"请选择职务名称"},on:{"change":_vm.onSelectPostChanged},model:{value:(_vm.selectPost),callback:function ($$v) {_vm.selectPost=$$v},expression:"selectPost"}},_vm._l((_vm.posts),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.label,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }